export const categories = [
    {
      id: 1,
      name: "Chicken",
      urlParamName: "chicken",
    },
    {
      id: 2,
      name: "Fruits",
      urlParamName: "fruits",
    },
    {
      id: 3,
      name: "Biriyani",
      urlParamName: "biriyani",
    },
    {
      id: 4,
      name: "Fish",
      urlParamName: "fish",
    },
    {
      id: 5,
      name: "Rice",
      urlParamName: "rice",
    },
    {
      id: 6,
      name: "Ice-creams",
      urlParamName: "icecreams",
    },
    {
      id: 7,
      name: "Soft Drinks",
      urlParamName: "drinks",
    },
    {
      id: 8,
      name: "Desserts",
      urlParamName: "desserts",
    },
  ];